import type { JSX } from 'react';

import { Card, Image, Link, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import type { InfoCardLinkType } from 'src/app/pages/about/main/shared/types';

export function InfoCardLink({ to, icon, title, description }: InfoCardLinkType): JSX.Element {
	return (
		<Card className="flex flex-col items-center justify-center p-4">
			<Image src={icon} alt="" className="h-16 w-16" />
			<Text as="h4" size="x-small" variant="heading" className="mt-4 text-center">
				<Translate value={title} />
			</Text>
			<Text as="p" className="mb-4 mt-2 text-center">
				<Translate value={description} />
			</Text>
			<Link href={to} data-qa="learn-more-link">
				<Translate value="fe.pages.about.learn_more_btn" />
			</Link>
		</Card>
	);
}
